import { WellButtonLabels } from '../app/components/wells/well-edit-buttons'
import { HttpVerb } from './api-types'

export type BackLink = {
  path: string
  label: string
}

export interface FormDelegate {
  setIsDirty: (isDirty: boolean) => void
  isFormDirty?: boolean
}

export enum WellMode {
  EDIT = 'edit',
  VIEW = 'view',
  NEW = 'new',
}

export interface PageNavigation {
  requestUrl: string
  saveUrl?: string
  publishUrl?: string
  method: HttpVerb
  cancelRoute: string
  saveAndContinueRoute: (id: string | number) => string | void
  saveAndReturnRoute?: string
  saveRouteNewId?: (id: string | number) => string
  // Use this to pass in extra state to when using history.push and  SaveRouteNewId
  navigateToSaveRouteState?: Record<string, any>
  // Use this to pass in extra state to when using history.push and  SaveAndContinueRoute
  navigateToSaveAndContinueRouteState?: Record<string, any>
  // Use this to pass in extra state to when using history.push and  CancelRoute
  cancelRouteState?: Record<string, any>
  // Use this property to set the label for the 'Save and continue' or 'Save and return' button
  saveAndNavigateLabel?: WellButtonLabels
  // Use this property to omit a button from the default actions
  omitButtons?: WellButtonLabels[]
  cancelButtonLabel?: WellButtonLabels
}
